import { PayLayout } from '@components/templates';
import { lazyWithReload } from '@shared/react/lazyWithReload';
import { Route } from 'react-router-dom';

import { apiDocumentationPath, disputeEvidenceBestPracticesPath, legalDocumentPath } from './urls';

const DisputeEvidenceBestPractices = lazyWithReload(() =>
  import('./pages/DisputeEvidenceBestPractices').then((m) => ({
    default: m.DisputeEvidenceBestPractices,
  }))
);

const LegalDocument = lazyWithReload(() =>
  import('./pages/LegalDocument').then((m) => ({
    default: m.LegalDocuments,
  }))
);

const ApiDocumentation = lazyWithReload(() =>
  import('./pages/ApiDocumentation').then((m) => ({
    default: m.ApiDocumentation,
  }))
);

export const DocumentRoutes = (
  <>
    <Route element={<PayLayout />}>
      <Route path={disputeEvidenceBestPracticesPath} element={<DisputeEvidenceBestPractices />} />
      <Route path={legalDocumentPath} element={<LegalDocument />} />
      <Route path={apiDocumentationPath} element={<ApiDocumentation />} />
    </Route>
  </>
);

export default DocumentRoutes;
